<template>
  <div>
    <Launchpad />
  </div>
</template>

<script>
import Launchpad from "@/components/app/Launchpad";
import LoginCheck from "@/mixins/LoginCheck";

export default {
  name: "mainScreen",
  components: {
    Launchpad
  },

  mixins: [LoginCheck]
};
</script>
